import PropTypes from 'prop-types';
import React from 'react';
import { Card as BootstrapCard } from 'react-bootstrap';

const Card = ({ title, children, ...props }) => {
  return (
    <BootstrapCard {...props}>
      <BootstrapCard.Body>
        {title && <BootstrapCard.Title>{title}</BootstrapCard.Title>}

        {children}
      </BootstrapCard.Body>
    </BootstrapCard>
  );
};

Card.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
};

export default Card;
